/*

THIS IS JUST AN EXAMPLE SET UP FOR A REDUCER.
WE CAN DO WHATEVER WE WANT IN IT I JUST WANTED TO GIVE A BASE SKELETON - SAMEER

*/

import * as types from '../actions/actionTypes';

const initialState = {
  isLoggedIn: false,
  email: '',
  firstName: '',
  lastName: '',
  phone: '',
  company: '',
  instructions: '',
  address: '',
  apartment: '',
  city: '',
  country: '',
  province: '',
  zip: '',
  saveInfo: false,
}

export const customerInfoReducer = (state = initialState, action) => {
  var newState = {...state};
  switch (action.type) {
    case types.SET_CUSTOMER_INFO:
      newState = {...action.payload}
      return newState;
      break;
    default:
      return state;
  }
}
